import * as types from './actionTypes';

export function getRawPrograms(rawPrograms) { return { type: types.RAW_PROGRAMS, rawPrograms };}
export const internalProgramsUpdate = (programs) => ({ type: types.RAW_PROGRAMS_UPDATE, programs });